/**
 * Created by chenjia on 2016/9/23.
 *
 * update by liuwenbin16 on 2019/02/24 for 新人价
 */
define(function(require,exports,module){
    var priceModel = require("../../model/priceModel/priceModel");
    var storeSelector = require('../storeSelector/storeSelector');

    var priceV2 = {
        skuArry: [],
        pageNum: 40,
        pin: "",
        /**
         * @param root: 根节点选择器，如 .floor #slide
         */
        init: function(root) {
            var self = this;
            if ($("#priceQuerySwitch").val() != "OFF") {
                self.skuArry = [];
                self.pin = storeSelector.getCookie("pin");
                self.getPrice(root);
            }
        },
        getPrice: function(root) {
            var self = this;

            var skuList = "";

            var skuObj;
            if(root) {
                skuObj = $(root).find("[skuid]")
            } else {
                skuObj = $("[skuid]");
            }

            skuObj.each(function() {
                if($(this).attr("hasPrice") !== "1") {
                    if($(this).attr("skuid").indexOf("J_") < 0) {
                        skuList = skuList + "," + "J_" + $(this).attr("skuid");
                    } else {
                        skuList = skuList + "," + $(this).attr("skuid");
                    }
                }
            });

            skuList = skuList.substring(1, skuList.length);
            skuList = skuList.split(",");

            var num = Math.ceil(skuList.length / self.pageNum);

            for (var i = 1; i <= num; i++) {
                var skuids = "";
                for (var j = (i - 1) * self.pageNum; j < i * self.pageNum; j++) {
                    if (typeof(skuList[j]) != "undefined") {
                        skuids = skuids + "," + skuList[j];
                    }
                }
                skuids = skuids.substring(1, skuids.length);

                if (skuids != "") {
                    self.skuArry.push(skuids);
                }
            }

            if (self.skuArry.length == 0) {
                return false;
            }
            for (var i = 0; i < self.skuArry.length; i++) {
                self.ajaxPrice(self.skuArry[i], self.pin);
            }
        },
        ajaxPrice: function(skuArry, pin) {
            var self = this;
            var arg = {"skuids": skuArry,"pin": pin,"ext": "00001000","source": "jdglobal"};

            priceModel.ajaxGetPrice(arg, function(data) {

                $.each(data, function() {
                    var newPrice = priceModel.formatPrice(this.p);
                    var oldPrice = priceModel.formatPrice(this.m);

                    var samPrice = null;
                    var plusPrice = null;
                    var newMemberPrice = null;
                    if (this.nup) {
                        newMemberPrice = priceModel.formatPrice(this.nup); //新人价
                    }
                    if(this.sp) {
                        samPrice = priceModel.formatPrice(this.sp); //山姆价
                    }
                    if(this.tpp){
                        plusPrice = priceModel.formatPrice(this.tpp); //plus价
                    }

                    var thisObj = $("[skuid='" + this.id + "']");

                    if (newPrice == "-1" || oldPrice == "-1") {
                        thisObj.find(".discount").remove();
                        return true;
                    };

                    //有颜色无套装（item-style-v3）时，价格跟随鼠标变化，plus/sams价格同时变化
                    if($('#plist').hasClass('item-style-v3')){
                        var _this = this;
                        showVipPrice($('.item .price span'));
                        $(".p-scroll .ps-item").hover(function() {
                            if($(this).hasClass('curr')){
                                var psItemSku = $(this).attr('skuid');
                                $(this).parents(".item").find('.price span').attr('psItemSku', psItemSku);
                            }
                            showVipPrice($(this).parents('.item').find(".price span"));
                        });
                        //判断价格为哪一个价格，以及是否展示plus/sams价格
                        function showVipPrice(ele){
                            var tppPlusPrice = null;
                            var spSamsPrice = null;
                            var nupNewMemberPrice = null;
                            ele.each(function() {
                                if($(this).attr('psitemsku') && $(this).attr('psitemsku') == _this.id){
                                    var vipPrice = $(this).siblings('.sam');
                                    $(this).html("<b>&yen;</b>" + priceModel.formatPrice(_this.p));

                                    if(_this.tpp){
                                        tppPlusPrice = priceModel.formatPrice(_this.tpp);
                                    }
                                    if(_this.sp){
                                        spSamsPrice = priceModel.formatPrice(_this.sp);
                                    }
                                    if (_this.nup) {
                                        nupNewMemberPrice = priceModel.formatPrice(_this.nup);
                                    }
                                    if(tppPlusPrice != null){
                                        vipPrice.html(`
                                            <div class="p-plus">&yen;${tppPlusPrice}</div>
                                            <i class="logo-plus"></i>
                                        `)
                                    }else if(spSamsPrice !== null){
                                        vipPrice.html(`
                                            <div class="p-sam">&yen;${spSamsPrice}</div>
                                            <i class="logo-sams"></i>
                                        `)
                                    } else if (nupNewMemberPrice !== null) {
                                        vipPrice.html(`
                                            <div class="p-nup">&yen;${nupNewMemberPrice}</div>
                                            <i class="logo-nup"></i>
                                        `)
                                    }
                                    else{
                                        vipPrice.html('')
                                    }
                                }
                            });
                        }
                    //无套装无颜色（item-style-v4）、有套装无颜色（item-style-v1）时价格和plus/sams价格展示
                    }else{
                        thisObj.find(".price span").each(function() {
                            if($(this).parents("[status]").attr("status") == "1") {
                                // 首页特卖楼层，如果status为0，表示非预告，请求实时价格；为1，表示预告，则使用配置的价格，只更新del中的价格
                            } else {
                                $(this).html("<b>&yen;</b>" + newPrice);
                            }
                        });                    

                        thisObj.parents('.gl-item').find(".price span").each(function() {
                            var samDiv = $(this).parent().find(".sam");
                            if(samDiv.length > 0){
                                if(plusPrice != null){
                                    samDiv.html(`
                                        <div class="p-plus">&yen;${plusPrice}</div>
                                        <i class="logo-plus"></i>
                                    `)
                                }else if(samPrice !== null){
                                    samDiv.html(`
                                        <div class="p-sam">&yen;${samPrice}</div>
                                        <i class="logo-sams"></i>
                                    `)
                                } else if (newMemberPrice !== null) {
                                    samDiv.html(`
                                        <div class="p-nup">&yen;${newMemberPrice}</div>
                                        <i class="logo-nup"></i>
                                    `)
                                }
                            }
                        });
                    }

                    thisObj.find(".price del").html("&yen;" + oldPrice);
                    thisObj.find(".price .consult").html("参考价&yen;<em>" + oldPrice + "</em>");

                    thisObj.attr("hasPrice","1");

                    var discount = priceModel.getDiscount(newPrice, oldPrice);

                    if(discount == "") {
                        thisObj.find(".discount").remove();
                    } else {
                        if(thisObj.parents(".w").parent().hasClass("special-sale")) {
                            thisObj.find(".discount").html('<div class="bg"><div class="poi"><span class="num">'+ discount +'</span><span>折</span></div></div>');
                        } else {
                            thisObj.find(".discount").html(discount + "折");
                        }
                    }
                });
            });
        }
    };
    module.exports = priceV2;
});



// WEBPACK FOOTER //
// ./src/js/unit/price/priceV2.js